// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../static/fonts/Aeonik-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../static/fonts/Aeonik-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("images/tooltip/star_with_circle_green.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: Aeonik;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: block;
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Aeonik";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
  font-display: block;
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "Aeonik";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
  font-display: block;
  font-weight: 500;
  font-style: normal;
}
body {
  margin: 0;
  padding: 0;
}

body {
  bottom: 0;
  font-family: "Aeonik", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-feature-settings: "tnum";
          font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  font-size: 11px;
  left: 0;
  margin: 0;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
}

input,
textarea {
  outline: none;
}

#app {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  min-height: 40px;
  max-height: 100vh;
  background-color: #F5F6F9;
  z-index: 100;
}

.customersCreateInvoice__premium {
  padding-right: 20px !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
  background-repeat: no-repeat !important;
  background-position: right 6px !important;
  background-size: 13px 13px !important;
}

.__legacy__CustomerQuotaExceeded {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  margin-bottom: 20px;
}
.__legacy__CustomerQuotaExceeded div:first-child {
  font-size: 12px;
  font-weight: bold;
  color: #D92D20;
  margin-bottom: 5px;
}
.__legacy__CustomerQuotaExceeded div:last-child {
  font-size: 12px;
  color: #002E33;
}

a {
  color: #002E33;
  padding: 0;
  margin: 0;
  -webkit-text-decoration: underline;
  text-decoration: underline;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(50%, transparent), color-stop(0%, #01FF94));
  background-image: linear-gradient(transparent 50%, #01FF94 0%);
  background-size: auto 200%;
  -webkit-transition: background 0.14s ease-in-out;
  transition: background 0.14s ease-in-out;
}
a:hover {
  background-position-y: 100%;
  -webkit-text-decoration: none;
  text-decoration: none;
}

/* Hide CookieBot Privacy trigger in webapp, still visible in credentials page and website */
#CookiebotWidget {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/client/App.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAEA;EACE,mBAAA;EACA,4CAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AADF;AAIA;EACE,qBAAA;EACA,4DAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAFF;AAMA;EACE,qBAAA;EACA,4DAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAJF;AAOA;EACE,SAAA;EACA,UAAA;AALF;;AAQA;EACE,SAAA;EACA,iCAAA;EACA,mCAAA;EACA,kCAAA;EACA,qCAAA;UAAA,6BAAA;EAAA,kCAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;AALF;;AAQA;;EAEE,aAAA;AALF;;AAQA;EACE,eAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBCDO;EDEP,YAAA;AALF;;AASE;EACE,8BAAA;EACA,oEAAA;EACA,uCAAA;EACA,yCAAA;EACA,qCAAA;AANJ;;AAWE;EACE,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,wBAAA;MAAA,qBAAA;UAAA,uBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,mBAAA;AARJ;AAUI;EACE,eAAA;EACA,iBAAA;EACA,cCzEA;ED0EA,kBAAA;AARN;AAWI;EACE,eAAA;EACA,cCxFS;AD+Ef;;AA8BA;EAfE,cC9Fa;ED+Fb,UAAA;EACA,SAAA;EACA,kCAAA;EAAA,0BAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,wHAAA;EAAA,8DAAA;EACA,0BAAA;EACA,gDAAA;EAAA,wCAAA;AAXF;AAaE;EACE,2BAAA;EACA,6BAAA;EAAA,qBAAA;AAXJ;;AAkBA,4FAAA;AACA;EACE,aAAA;AAfF","sourcesContent":["@import \"../client/Global/Colors.scss\";\n\n@font-face {\n  font-family: Aeonik;\n  src: url('../static/fonts/Aeonik-Regular.woff2');\n  font-display: block;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'Aeonik';\n  src: url('../static/fonts/Aeonik-Bold.woff2') format('woff2');\n  font-display: block;\n  font-weight: 700;\n  font-style: normal;\n}\n\n// this fallback may be also needed if you use \"font-weight: 500\" in css, or even another one for \"600\"\n@font-face {\n  font-family: 'Aeonik';\n  src: url('../static/fonts/Aeonik-Bold.woff2') format('woff2');\n  font-display: block;\n  font-weight: 500;\n  font-style: normal;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  bottom: 0;\n  font-family: \"Aeonik\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-variant-numeric: tabular-nums;\n  font-size: 11px;\n  left: 0;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\ninput,\ntextarea {\n  outline: none;\n}\n\n#app {\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100vw;\n  min-height: 40px;\n  max-height: 100vh;\n  background-color: $Gray20;\n  z-index: 100;\n}\n\n.customersCreateInvoice {\n  &__premium {\n    padding-right: 20px !important;\n    background-image: url('~images/tooltip/star_with_circle_green.svg') !important;\n    background-repeat: no-repeat !important;\n    background-position: right 6px !important;\n    background-size: 13px 13px !important;\n  }\n}\n\n.__legacy {\n  &__CustomerQuotaExceeded {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 20px;\n\n    div:first-child {\n      font-size: 12px;\n      font-weight: bold;\n      color: $Red;\n      margin-bottom: 5px;\n    }\n\n    div:last-child {\n      font-size: 12px;\n      color: $DeepSeaGreen;\n    }\n  }\n}\n\n@mixin linkRules {\n  color: $DeepSeaGreen;\n  padding: 0;\n  margin: 0;\n  text-decoration: underline;\n  width: fit-content;\n  background-image: linear-gradient(transparent 50%, $ElectricGreen 0%);\n  background-size: auto 200%;\n  transition: background 0.14s ease-in-out;\n\n  &:hover {\n    background-position-y: 100%;\n    text-decoration: none;\n  }\n}\n\na {\n  @include linkRules;\n}\n/* Hide CookieBot Privacy trigger in webapp, still visible in credentials page and website */\n#CookiebotWidget {\n  display: none;\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
